export default __webpack_public_path__ + "static/media/SEC3070.34I-43638_-26073_0.cc86c056.jpg";